import { render, staticRenderFns } from "./add-client-follow.vue?vue&type=template&id=7383e3d6&scoped=true&"
import script from "./add-client-follow.vue?vue&type=script&lang=js&"
export * from "./add-client-follow.vue?vue&type=script&lang=js&"
import style0 from "./add-client-follow.vue?vue&type=style&index=0&id=7383e3d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7383e3d6",
  null
  
)

export default component.exports